<div class="welcome-wizard-volume-page-container container" [formGroup]="form">
  <div class="panel-container container" fxLayout="column" fxLayoutGap="15px">

    <!-- Sales Volume Display Mode -->
    <p>{{ 'sales_volume_preference.description' | translate }}</p>
    <mat-radio-group color="primary" formControlName="salesVolumeDisplayMode" fxLayout="column" fxLayoutGap="5px" aria-label="Select Sales Volume Mode">
      <mat-radio-button [value]="SalesVolumeDisplayModeType.ANNUAL">{{ 'sales_volume_preference.annual' | translate }}</mat-radio-button>
      <mat-radio-button [value]="SalesVolumeDisplayModeType.WEEKLY">{{ 'sales_volume_preference.weekly' | translate }}</mat-radio-button>
    </mat-radio-group>

    <!-- Sales Volume Example -->
    <div class="container">
      <p class="color-muted">{{ 'sales_volume_preference.example' | translate }}</p>
      <mtn-sales-volume-view [volume]="sampleVolume"
                             [salesVolumeDisplayMode]="form.get('salesVolumeDisplayMode').value">
      </mtn-sales-volume-view>
    </div>
  </div>

  <br/>

  <div class="panel-container container" fxLayout="column" fxLayoutGap="15px">

    <!-- Sales per Sqft Display Mode -->
    <p>{{ 'sales_sqft_preference.description' | translate }}</p>
    <mat-radio-group color="primary" formControlName="salesSqftDisplayMode" fxLayout="column" fxLayoutGap="5px" aria-label="Select Sales per Sqft Mode">
      <mat-radio-button [value]="SalesSqftDisplayModeType.SALES_AREA">{{ 'sales_sqft_preference.sales_area' | translate }}</mat-radio-button>
      <mat-radio-button [value]="SalesSqftDisplayModeType.TOTAL_AREA">{{ 'sales_sqft_preference.total_area' | translate }}</mat-radio-button>
    </mat-radio-group>

    <!-- Sales per Sqft Example -->
    <div class="container">
      <p class="color-muted">{{ 'sales_sqft_preference.example' | translate }}</p>
      <mtn-sales-sqft-view [volume]="sampleVolume"></mtn-sales-sqft-view>
    </div>
  </div>
</div>
